/**
 * 轻量 HTML 消毒：去 script/iframe 等与 on* / javascript: 属性。
 * 用于公告、待办、仓库地址等 v-html 场景（无额外依赖）。
 */
export function sanitizeHtml(html) {
  if (html == null || html === '') return ''
  if (typeof window === 'undefined' || !window.DOMParser) {
    return String(html)
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
  }
  const doc = new DOMParser().parseFromString(String(html), 'text/html')
  doc.querySelectorAll('script,iframe,object,embed,link,meta,style,form').forEach((n) => n.remove())
  doc.querySelectorAll('*').forEach((el) => {
    Array.from(el.attributes).forEach((attr) => {
      const name = attr.name || ''
      const val = attr.value || ''
      if (/^on/i.test(name) || (name === 'href' && /^\s*javascript:/i.test(val))) {
        el.removeAttribute(name)
      }
    })
  })
  return doc.body.innerHTML
}
